<template>
    <v-app-bar app clipped-left light color="white" class="roma-app-bar" >
        <!-- desktop -->
        <v-app-bar-nav-icon
            @click.stop="dpDrawer()"
            class="ml-2 mr-3 ml-md-2 mr-md-3 d-none d-lg-block"
        ></v-app-bar-nav-icon>

        <!-- mobile -->
        <v-app-bar-nav-icon
            @click.stop="dpTemporary()"
            class="ml-2 mr-3 ml-md-2 mr-md-3 d-block d-lg-none"
        ></v-app-bar-nav-icon>

        <!-- BrandLogo -->
        <router-link
            to="/"
            class="brand-logo pr-0 order-3  mr-12"
        >
            <img src="@/assets/images/logo-roma.svg" class="" alt="" />
        </router-link>
        <!-- mobile spacer -->
        <v-spacer class="d-block d-sm-none order-2"></v-spacer>

        <!-- title -->
        <!-- <v-toolbar-title
            color="red"
            class="roma-toolbar-title order-1 order-sm-3"
        >
            Aula Virtual
        </v-toolbar-title> -->
        <!-- tablet spacer -->
        <v-spacer class="d-none d-sm-block order-4"></v-spacer>

        <!-- institution information -->
        <div class="order-3 d-flex" v-if="$route.name !== 'ErrorPage'">
            <!-- information -->
            <div class="user align-center d-flex">
                <template v-if="user.institutionContext">
                    <div class="user__icon mr-5">
                        <v-img
                            :src="
                                `https://plataforma.romacl.com/LogoInstitucion?id=${user.institutionContext.identificationCode}`
                            "
                            :lazy-src="
                                `https://plataforma.romacl.com/LogoInstitucion?id=${user.institutionContext.identificationCode}`
                            "
                            width="30px"
                        ></v-img>
                    </div>

                    <div class="user__information d-none d-md-flex flex-column">
                        <p clasS="user__name text-uppercase ">
                            {{ user.institutionContext.identificationCode }}-{{
                                user.institutionContext.name
                            }} 
                        </p>
                        <p class="user__period cardTitle--text text-uppercase">
                            AÑO ESCOLAR
                            {{ user.institutionContext.yearSelected }}
                        </p>
                    </div>
                </template>
            </div>
        </div>

        <div class="order-5 d-flex " v-if="$route.name !== 'ErrorPage'">
            <div class="d-flex align-center roma-app-bar__avatar-wrapper">
                <div class="text-right d-none d-sm-flex">
                    <p class="roma-app-bar__name">{{ user.fullName }}</p>
                </div>
                <!-- avatar -->

                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-avatar   
                            v-bind="attrs"
                            v-on="on"
                            color="white"
                            class="d-sm-block roma-app-bar__avatar ml-4"
                        >
                            <img
                                src="@/assets/images/avatar_default.png"
                                alt="John"
                            />
                        </v-avatar>
                    </template>
                    <v-list>
                        <v-list-item
                            v-for="(item, index) in userMenuOptions"
                            :key="index"
                            link
                            @click="item.action"
                        >
                            <v-list-item-icon>
                                <v-icon v-text="item.icon"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{
                                item.title
                            }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>
        </div>
    </v-app-bar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    props: {
        dpDrawer: {
            type: Function
        },
        dpTemporary: {
            type: Function
        }
    },
    data() {
        return {
            userMenuOptions: [
                {
                    icon: "mdi-location-exit",
                    title: "Cerrar sesión",
                    action: () => {
                        this.actionLogout();
                        localStorage.clear();
                        window.location = process.env.VUE_APP_ROMA_LOGOUT_CAS;
                    }
                }
            ]
        };
    },
    methods: {
        ...mapActions({
            toggleDrawer: "toggleDrawer",
            actionLogout: "actionLogout"
        })
    },
    computed: {
        ...mapGetters({
            user: "getUserData"
        })
    }
};
</script>

<style lang="scss">
.roma-app-bar {
    z-index: 100;
    .user {
        &__name,
        &__period {
            font-size: 15px;
        }
    }
    .roma-toolbar-title.roma-toolbar-title {
        font-size: 27px;
        color: #262626;
    }
    .brand-logo {
        // width: 175px;
        height: 40px;
        img {
            width: auto;
            height: 100%;
        }
    }
    &__avatar-wrapper {
        // margin-left: 70px;
    }

    @media (min-width: 1904px) {
        .v-toolbar__content {
            height: 92px;
        }
        .user {
            &__name,
            &__period {
                font-size: 16px;
            }
        }
        .roma-toolbar-title.roma-toolbar-title {
            font-size: 27px;
        }
        .brand-logo {
            height: 40px;
        }
        &__avatar {
            height: 60px !important;
            min-width: 60px !important;
            width: 60px !important;
        }
    }
    @media (min-width: 1264px) and (max-width: 1903px) {
        .v-toolbar__content {
            height: 79px;
        }
        .user {
            &__name,
            &__period {
                font-size: 15px;
            }
        }
        .roma-toolbar-title.roma-toolbar-title {
            font-size: 23px;
        }
        .brand-logo {
            height: 23px;
        }
        &__avatar {
            height: 45px !important;
            min-width: 45px !important;
            width: 45px !important;
        }
    }
    @media (min-width: 960px) and (max-width: 1263px) {
        .v-toolbar__content {
            height: 61px;
        }
        .user {
            &__name,
            &__period {
                font-size: 9px;
            }
        }
        .roma-toolbar-title.roma-toolbar-title {
            font-size: 17px;
        }
        .brand-logo {
            height: 18px;
        }
        &__avatar {
            height: 35px !important;
            min-width: 35px !important;
            width: 35px !important;
        }
    }
    @media (min-width: 600px) and (max-width: 959px) {
        .v-toolbar__content {
            height: 58px;
        }
        .roma-toolbar-title.roma-toolbar-title {
            font-size: 15px;
        }
        .brand-logo {
            height: 18px;
        }
        &__avatar {
            height: 27px !important;
            min-width: 27px !important;
            width: 27px !important;
        }
    }
    @media (max-width: 599px) {
        .v-toolbar__content {
            height: 58px;
        }
        .roma-toolbar-title.roma-toolbar-title {
            font-size: 15px;
        }
        .brand-logo {
            height: 22px;
        }
    }
}
</style>
